const url = `${process.env.GATSBY_BASE_URL}/apply`

function errorResponseMock(status_code, message) {
  const exception = new Error()
  exception.response = {
    status: status_code,
    data: {
      error: message
    }
  }
  throw exception
}

function successfullResponseMock(response, segmentAnonymousID) {
  const customerApplicationId = response.url.match(/\d+/g).join('')
  const data = {
    success: true,
    applicationURL:
      segmentAnonymousID !== null
        ? `${url}/${customerApplicationId}?segment_id=${segmentAnonymousID}`
        : `${url}/${customerApplicationId}`
  }
  return data
}

async function fakeRequest(segmentAnonymousID) {
  const fakeResponse = await fetch(url, {
    headers: {
      'accept-language': 'en-US,en;q=0.8',
      'sec-fetch-dest': 'document',
      'sec-fetch-mode': 'navigate'
    },
    referrerPolicy: 'strict-origin-when-cross-origin',
    body: null,
    method: 'GET',
    credentials: 'include'
  }).catch(() => {
    errorResponseMock(500, 'Error in the server side')
  })
  return successfullResponseMock(fakeResponse, segmentAnonymousID)
}

export async function myAvantEndpointMock(code, ssn, segmentAnonymousID) {
  try {
    if (code !== '1234-56-7890' || ssn !== '1111') {
      errorResponseMock(
        404,
        'We could not find your offer code. That combination did not match a valid personal offer.'
      )
    }
    const response = await fakeRequest(segmentAnonymousID)
    return response
  } catch (error) {
    return Promise.reject(error)
  }
}
